import { render, staticRenderFns } from "./refund-records.vue?vue&type=template&id=0895724c&"
import script from "./refund-records.vue?vue&type=script&lang=ts&"
export * from "./refund-records.vue?vue&type=script&lang=ts&"
import style0 from "./refund-records.vue?vue&type=style&index=0&id=0895724c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports